import apiClient from './axios';
import { appConfig } from '../config/app.config';

const fetchBaseQuery =
  ({ baseUrl = appConfig.baseUrl }) =>
  async ({ url, method = 'get', data, params, headers }) => {
    try {
      const result = await apiClient({
        url,
        method,
        data,
        params,
        headers,
        baseURL: baseUrl,
      });
      return { data: { data: result.data } };
    } catch (axiosError) {
      const err = axiosError;

      const status = err.response?.status ?? 500;

      let data = {
        status: false,
        message: err.message || `Request failed with status ${status}`,
        data: null,
        code: status,
      };

      if (typeof err.response?.data === 'object') {
        let message = '';
        if (err.response?.data?.message) {
          message = err.response?.data.message;
        } else if (err.response?.data?.error) {
          message = err.response?.data.error;
        } else if (typeof err.response?.data?.detail === 'string') {
          message = err.response?.data.detail;
        }
        if (!message) {
          message = err.message || `Request failed with status ${status}`;
        }
        data = {
          status: false,
          message,
          data: err.response?.data ?? null,
          code: status,
        };
      }

      if (typeof err.response?.data === 'string') {
        data = {
          status: false,
          message: err.response.data || err.message || `Request failed with status ${status}`,
          data: null,
          code: status,
        };
      }

      return { error: data };
    }
  };

export const transformResponse = (response) => {
  return response.data;
};

export const axiosBaseQuery = fetchBaseQuery({ baseUrl: appConfig.baseUrl });
export const baseURL = appConfig.baseUrl;

export default axiosBaseQuery;



